module.exports = __webpack_public_path__ + "static/media/clientid.d5dd46f7.svg";